import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {FormattedMessage} from 'react-intl';

import {Icon} from '@stubhub/bamboo';
import TrustMessage from '@stubhub/react-trust-message';

import CollapsibleItem from './collapsible-item';
import messages from './messages';

import '../styles/index.scss';

const FanProtect = ({className, legalLink}) => (
  <div className={cs('FanProtect', className)}>
    <CollapsibleItem
      title={<FormattedMessage {...messages.FANPROTECT_TITLE} />}
      info={<FormattedMessage {...messages.FANPROTECT_INFO} values={{legalLink}} />}
      icon={<Icon name="FanProtect" size="md" className="TrustMessage__icon" />}
    >
      <TrustMessage info={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY} />} />
      <TrustMessage info={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_CLAIM} />} />
      <address>
        <TrustMessage
          info={
            <FormattedMessage
              {...messages.FAN_PROTECT_WARRANTY_ADDRESS}
              values={{
                email: <a href="mailto: kundendienst@stubhub.de">kundendienst@stubhub.de</a>,
              }}
            />
          }
        />
      </address>
    </CollapsibleItem>
    <CollapsibleItem
      title={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_TITLE} />}
      info={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_RIGHTS_SUMMARY} />}
      icon={<Icon name="FanProtect" size="md" className="TrustMessage__icon" />}
    >
      <TrustMessage info={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_RIGHTS} />} />
    </CollapsibleItem>
    <CollapsibleItem
      title={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_TITLE} />}
      info={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_CONTRACT_SUMMARY} />}
      icon={<Icon name="PrimaryPartner" size="md" className="TrustMessage__icon" />}
    >
      <TrustMessage info={<FormattedMessage {...messages.FAN_PROTECT_WARRANTY_CONTRACT} />} />
    </CollapsibleItem>
  </div>
);

FanProtect.propTypes = {
  /** Custom classname */
  className: PropTypes.string,

  /** Legal link to use */
  legalLink: PropTypes.elementType.isRequired,
};

export default FanProtect;
